import axios from 'axios';

// Definir la URL base desde variables de entorno o un valor predeterminado
const API_BASE_URL = process.env.REACT_APP_API_BASE_URL || 'https://sistema.notaria4otavalo.com.ec';

// Crear instancia de axios con configuración base
const api = axios.create({
  baseURL: API_BASE_URL,
  headers: { 'Content-Type': 'application/json' },
});

// Interceptor para agregar el token de autenticación
api.interceptors.request.use(
  (config) => {
    const token = localStorage.getItem('token');
    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
    }
    return config;
  },
  (error) => Promise.reject(error)
);

// Interceptor para manejar errores de respuesta
api.interceptors.response.use(
  (response) => response,
  (error) => {
    const message = error.response?.data?.error || 'Error en la solicitud al servidor.';
    const details = error.response?.data?.detalle ? JSON.stringify(error.response.data.detalle) : '';
    // Usar toast para mostrar errores en el frontend (como en JustifyDeposits.jsx)
    if (typeof window !== 'undefined' && window.toast) {
      window.toast.error(`${message} ${details}`, { position: 'top-right', autoClose: 5000 });
    }
    return Promise.reject(error);
  }
);

export default api;